import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

// Frontend-managed "Pick for" descriptions shown in the InfoTooltip.
// Only group (provider) rows are described here — individual models show the
// backend's own IAIVideoModel.description. The literal "Pick for:" prefix lives
// on the tooltip label itself; the strings here are just the predicate.
//
// Group keys mirror IAIVideoModel.code.

export const getGroupDescription = (groupKey: string): string => {
  switch (groupKey) {
    case 'renderforest':
      return translate(T.VIDEO_PICK_FOR_RENDERFOREST)
    case 'bytePlus':
      return translate(T.VIDEO_PICK_FOR_SEEDANCE)
    case 'pixVerse':
      return translate(T.VIDEO_PICK_FOR_PIXVERSE)
    case 'kling':
      return translate(T.VIDEO_PICK_FOR_KLING)
    case 'google':
      return translate(T.VIDEO_PICK_FOR_VEO)
    case 'miniMax':
      return translate(T.VIDEO_PICK_FOR_HAILUO)
    default:
      return ''
  }
}
